export const SET_COLUMNS = "SET_COLUMNS"